<template>
  <a @click="$router.go(-1)" class="vc-back-btn"><i class="_icon" /></a>
</template>

<script>
export default {
  name: "NavBackBtn",
};
</script>

<style lang="less" scoped>
@color: #181949;

.vc-back-btn {
  height: 44px;
  width: 44px;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;

  ._icon {
    opacity: 0.5;
    border: 10px solid transparent;
    border-right: 10px solid @color;
    left: 7px;
    position: absolute;
  }
  ._icon:active {
    opacity: 1;
  }
  ._icon:after {
    content: "";
    position: absolute;
    top: -10px;
    left: -7px;
    border: 10px solid transparent;
    border-right: 10px solid #fff;
  }
}
</style>